// extracted by mini-css-extract-plugin
module.exports = {"container":"VisuallyHidden_container__DSOLo"};